"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAID_LINK_CUSTOMIZATION_NAMES = void 0;
// These correspond to values in the Plaid dashboard
// https://dashboard.plaid.com/link
var PLAID_LINK_CUSTOMIZATION_NAMES;
(function (PLAID_LINK_CUSTOMIZATION_NAMES) {
    PLAID_LINK_CUSTOMIZATION_NAMES["default"] = "default";
    PLAID_LINK_CUSTOMIZATION_NAMES["idr"] = "idr_plaid";
    PLAID_LINK_CUSTOMIZATION_NAMES["loanSync"] = "loan_sync";
    PLAID_LINK_CUSTOMIZATION_NAMES["solstice"] = "solstice";
    PLAID_LINK_CUSTOMIZATION_NAMES["emergency_savings"] = "emergency_savings";
})(PLAID_LINK_CUSTOMIZATION_NAMES || (exports.PLAID_LINK_CUSTOMIZATION_NAMES = PLAID_LINK_CUSTOMIZATION_NAMES = {}));
